$(document).on('turbolinks:load', function() {
  $('.form-wizard').on('submit', function(event) {
    if (!event.originalEvent.defaultPrevented) {
      $('.form-wizard').loading();
    }
  });
});
